import { Component, OnInit } from '@angular/core';
import { Attachments, Blogs } from '../../models/blogs';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import * as momentHijri from 'moment-hijri';
import { FileVm } from '../../../../shared/Models/fileVm';
import { BlogsService } from '../../services/blogs-service';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';


@Component({
  selector: 'app-get-blogs-details',
  templateUrl: './get-blogs-details.component.html',
  styleUrls: ['./get-blogs-details.component.scss']
})
export class GetBlogsDetailsComponent implements OnInit {

  model = {} as Blogs;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetBlogsDetailsComponent>,
    public sanitizer: DomSanitizer,
    private service : BlogsService
  ) {
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });  
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

   getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
    }

    getAllVideos(videos:Attachments[]):FileVm[]
    {
      let AllVideos = []
      if(videos.length>0)
      {
        for(var video of this.model.videos)
        {
           video.groupItems.forEach((items)=>{
            AllVideos.push(items)
          })         
        }
      }
      return  AllVideos;
    }

    
    getAllImages(images:Attachments[]):FileVm[]
    {
      let AllImages = []
      if(images.length>0)
      {
        for(var image of this.model.images)
        {
          image.groupItems.forEach((items)=>{
             AllImages.push(items)
          })      
        }
      }
      return  AllImages;
    }

      downloadFile(fileName) {
        this.service.downloadFile(fileName).subscribe((blob) => {
          downloadFileUtil(blob, fileName);
        });
      }

}
